import { FurnitureContainer } from '../../containers/advancedFilters/FurnitureContainer';
import { IFilter } from '../../types/advancedFilters';

export const furniture: IFilter = {
  component: FurnitureContainer,
};
